import { TransactionData } from "./TransactionsTab";

export enum ProfileLevels {
  STARTER = 0,
  ADVANCED = 1,
  CUSTOM = 2,
}

export enum PaymentOption {
  INVOICE,
  CARD,
  BONUS,
  CRYPTO,
}

export interface UserData {
  id: number;
  name: string;
  email: string;
  avatarUrl: string;
  connectedApps?: AppData[];
  campaigns?: CampaignData[];
  payments?: PaymentData[];
  invoices?: PaymentData[];
  userPricing?: PriceSettingRow;
  totalSpendings: number;
  balance: number;
  profileLevel: ProfileLevels;
  telegram: string;
  phone: string;
  applicationLimit: number;
  keywordLimit: number;
}

export interface AppData {
  key?: string;
  uniqueKey?: string;
  title: string;
  appId?: string;
  store: string;
  country: string;
  score: number;
  reviews: number;
  version: string;
  updated: string;
  size: number;
  status?: string;
}

export interface CampaignData {
  id: number;
  manager: string;
  user: string;
  userStatus: string;
  app: string;
  keyword: string;
  platform: string;
  country: string;
}

// export interface TransactionData {
// 	date: Date;
// 	paymentOption: string;
// 	idNumber: string;
// 	depositAmount: number;
// 	depositDate: Date;
// 	bankName?: string;
// }

export interface InvoiceData {
  depositDate: string;
  email: string;
  depositAmount: number;
  bankName: string;
  accountNumber: string;
  accountHolderName: string;
  routingNumber: string;
}

export interface PaymentData extends TransactionData {
  email: string;
  accountNumber: string;
  accountHolderName: string;
  routingNumber: string;
  bankName?: string;
}

export interface StorePricing {
  VISIT: number;
  APP_OPENING: number;
  DIRECT: number;
  KEYWORDS: number;
  /** Empty (null) while Keyword PRO has no price, it can't be ordered then. */
  KEYWORDS_PRO?: number | null;
  RATINGS: number;
  REVIEWS: number;
}

export interface Limits {
  apps: number;
  keywords: number;
}

export interface PriceSettingRow {
  codeOfCountry: string;
  country: string;
  APP_STORE: StorePricing;
  GOOGLE_STORE: StorePricing;
  LIMITS?: Limits;
}
